import { useEffect } from "react";
import { FormatCurrency, sortArrayObject } from "../functionsGlobal";
import { updateState } from "../headerColumns";
import { useIsloading } from "./useIsloading";

let orderArray = 'ASC';
let countOrder = 0;
let keyOld = '';
const rowsOld = [];
let nameOfComponentYouOrdered;

export const useTableItems = (props) => {
    const {isloading, setIsloading} = useIsloading();
    const {
        handleClick = () => {}, handleClickCheck = () => {}, handleClickDelete = () => {}, valueState, setState = () => {},
        nameState, tab = false, verifyTabToSaveGrid, aggregation, order = true, handleUpdateCell = () => {},
        getRowClassName = () => {}, getRowTdClassName = () => {}, handleClickButton = () => {}, keyElement = null
    } = props;
    let {columns, rows} = valueState[0];

    useEffect(() => {
        if(rows.length > 0){
            const resultFilter = columns.filter((item) => item.order !== '')
            if(resultFilter.length > 0) return setIsloading(false);
        }
    
    }, [])

    useEffect(() => {
        if(rows.length > 0 || rowsOld.length === 0)  {

            if (nameOfComponentYouOrdered === nameState ){
                rowsOld.splice(0);
                rowsOld.push(...rows)
            }
            return setIsloading(false);

        };
    }, [rows])    

    const verifyIndexAggregation = () => {
        if(aggregation?.model){
            const key = Object.entries(aggregation.model).map(([key, value]) => {
                return key
            })
            return key
        }
        return null
    }

    const aggregationColumns = verifyIndexAggregation()

    const aggregationSum = (aggregation) => {
        let total = 0;
        if(aggregationColumns?.length > 0) total = parseFloat(rows.map(item => parseFloat(item[aggregation])).reduce((item, item2) => item +  item2, 0).toFixed(2))
        return FormatCurrency(total ?? 0)
    }

    const aggregationCount = (aggregation) => {
        let count = 0;
        if(aggregationColumns?.length > 0) count = parseFloat(rows.map(item => parseFloat(item[aggregation])).reduce((accumulator, current) => accumulator + 1, 0).toFixed(2))
        return count
    }

    const dragStart = (ev, columnIndex) => ev.dataTransfer.setData('columnIndex', columnIndex);

    const onDrop = (ev, columnIndex) => {
        ev.preventDefault();
        const dragIndex =parseInt(ev.dataTransfer.getData('columnIndex'));

        if (dragIndex !== columnIndex) {
            const newColumns = [...columns];
            const [draggedColumn] = newColumns.splice(dragIndex, 1);
            newColumns.splice(columnIndex, 0, draggedColumn);  
            columns = newColumns;
            if(tab) {
                const name = verifyTabToSaveGrid();
                updateState(name, valueState, columns, 'columns', setState);
                return 
            }
            updateState(nameState, valueState, columns, 'columns', setState);
        }
    }

    const allowDrop= (e) =>  e.preventDefault();

    const handleOrderArray = (key) => {
        if(!order) return;
        nameOfComponentYouOrdered = nameState;
        const {field, type} = key;
        const sortingResult = [];

        if(type === 'dropDown', type === '' || type === 'check' || type === 'delete') return;
        if ((keyOld === field) || keyOld === '') countOrder++

        orderArray = orderArray === 'ASC' ? 'DESC' : 'ASC';
        if(countOrder <= 2 ) {
            if(rows.length === 0) return 
            sortingResult.push(...sortArrayObject(rows, orderArray, field, type))
        }
        else {
            sortingResult.push(...rowsOld);
            countOrder = 0;
            orderArray = ''
        };
 
        keyOld = field;
        columns.map(item => {
            if (item.field === field){
                if(item.order === '' && (orderArray === '' || countOrder === 0)) return item.order = ''
                else item.order = orderArray;
            }
            else item.order = ''
        })

        if(tab) {
            const name = verifyTabToSaveGrid();
            updateState(name, valueState, sortingResult, 'rows', setState);
            return;
        }
        updateState(nameState, valueState, sortingResult, 'rows', setState);
    } 

    const onChangeCell = (index, field, value, column) => {

        let parsedValue = column?.valueParser ? column.valueParser(value) : value;
        
        setState((prev) => {
            prev[0].rows.map((row, i) => {

                if(i === index){
                    row[field] = parsedValue
                }

                return row
            })

            return [...prev]
            }
        );

        if (handleUpdateCell) handleUpdateCell(rows[index], field, value);
    };

    const handlersClicks = (item, index) => {
        if(handleClickButton)  handleClickButton(item, index)
        if(handleClickCheck)  handleClickCheck(item, index)
        if(handleClickDelete)  handleClickDelete(item, index)

    }

    return { 
        columns, rows, dragStart, allowDrop, onDrop, handleOrderArray, aggregationSum, isloading, handleClick,
        handleClickCheck, aggregation, aggregationCount, order, handleClickDelete, getRowClassName, handleUpdateCell,
        setState, onChangeCell, handlersClicks, keyElement, getRowTdClassName
    }

}